// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"tZ-z","sponsoredTooltipWrapper":"uZ-z","sponsoredTooltip":"vZ-z","newCard":"wZ-z"};